import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapperWithholding = styled.div`
  margin-top: ${rem('37px')};
  text-align: center;
`;

export { StyledWrapperWithholding };
